import { Controller } from "@hotwired/stimulus"

// Glide type pickers: the budget form (Free / Needs / Wants) and the category
// edit Need / Want toggle. The checked radio's value lands on data-kind; CSS
// slides and tints the thumb and swaps the hint.
//
// On a new budget (names value present) it also fills the name field with
// the picked type's label, but only while the name is still one of those
// auto labels (or blank), so a name the user typed is never overwritten.
export default class extends Controller {
  static values = { names: Object }

  select(event) {
    const kind = event.target.value
    this.element.dataset.kind = kind
    this.#autofillName(kind)
  }

  #autofillName(kind) {
    const names = this.namesValue
    if (!names[kind]) return

    const field = this.element.closest("form")?.querySelector('input[name="budget[name]"]')
    if (!field) return

    const current = field.value.trim()
    if (current !== "" && !Object.values(names).includes(current)) return

    field.value = names[kind]
    field.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
